/**
 * Created by lenovo on 2017/3/7.
 */
// export const ellaUrl =  "http://beiang.lierda.com:9011/challenger";
// export const bumpUrl =  "http://beiang.lierda.com:9001/columbia";
// export const ellaUrl =  "http://116.62.148.255:9011/challenger";//线上
// export const bumpUrl =  "http://116.62.148.255:9001/columbia";//线上
export const ellaUrl =  "http://app.us.beiangkeji.com:9011/challenger";//线上国外
export const bumpUrl =  "http://app.us.beiangkeji.com:9001/columbia";//线上国外
export const menuList = {'ella': 0, 'bump': 1, 'dealer': 2, 'mica': 3, 'lease': 4};
export function getMenuId(name) {
    switch (name) {
        case 'ella':
            return 0;
            break;

        case 'bump':
            return 1;
            break;
        case 'dealer':
            return 2;
            break;
        case 'mica':
            return 3;
            break;
        case 'lease':
            return 4;
            break;
        default:
            return 0;
            break;
    }
}


// WEBPACK FOOTER //
// ./modules/path.config.js